import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { createFetch, createSchema } from '@better-fetch/fetch';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

// types
import { CavernFileType, DataItemType } from '../../utils/types';

// functions

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface ProjectState {
  //
  loadingCavernFiles: boolean;
  loadingRucioFiles: boolean;
  latestQueryID: number;
  renamingFile: boolean;
  deletingFile: boolean;
  projectItems: DataItemType[];
  userItems: CavernFileType[];
  errorMessage: string;
  refreshCavernFiles: boolean;
  //
} // ProjectState

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: ProjectState = {
  loadingCavernFiles: false,
  loadingRucioFiles: false,
  latestQueryID: -1,
  renamingFile: false,
  deletingFile: false,
  projectItems: [],
  userItems: [],
  errorMessage: '',
  refreshCavernFiles: false,
};

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const projectSlice = createSlice({
  name: 'project',
  initialState: initialState,
  reducers: {
    //
    setDeletingFile: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.deletingFile = action.payload;
    },

    setErrorMessage: (state: ProjectState, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },

    setLatestQueryID: (state: ProjectState, action: PayloadAction<number>) => {
      state.latestQueryID = action.payload;
    },

    setLoadingCavernFiles: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.loadingCavernFiles = action.payload;
    },

    setLoadingRucioFiles: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.loadingRucioFiles = action.payload;
    },

    setProjectItems: (state: ProjectState, action: PayloadAction<DataItemType[]>) => {
      state.projectItems = action.payload;
    },

    setRefreshCavernFiles: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.refreshCavernFiles = action.payload;
    },

    setRenamingFile: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.renamingFile = action.payload;
    },

    setUserItems: (state: ProjectState, action: PayloadAction<CavernFileType[]>) => {
      state.userItems = action.payload;
    },
    //
  },
  //extraReducers: (builder) => {
  //  builder
  //    .addCase(initiateDMSearch.fulfilled, (state: FileBrowserState) => {})
  //},
});

// expose the interface.
export const {
  setDeletingFile,
  setErrorMessage,
  setLatestQueryID,
  setLoadingCavernFiles,
  setLoadingRucioFiles,
  setProjectItems,
  setRefreshCavernFiles,
  setRenamingFile,
  setUserItems,
} = projectSlice.actions;
export default projectSlice.reducer;
